import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';

class TableHome extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        homes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/home/detail/${rowData.id}` });
    };

    renderData = memoizeOne(homes => {
        let result = [];

        homes.map((home, homeId) => {
            result.push({
                id: parseInt(homeId),
                label: home.get('label'),
                homeState: home.get('homeState'),
                address: home.get('address'),
                city: home.get('city'),
                postalCode: home.get('postalCode'),
                weatherCity: home.get('weatherCity'),
                isThreephase: home.get('isThreephase') ? Translator.translate('general.yes') : Translator.translate('general.no'),
                apNum: home.get('apNum')
            });
        });

        return result;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('homeDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'id',
                defaultSort: 'asc'
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.address'),
                name: 'address'
            },
            {
                title: Translator.translate('general.table.column.city'),
                name: 'city'
            },
            {
                title: Translator.translate('general.table.column.postalCode'),
                name: 'postalCode'
            },
            {
                title: Translator.translate('general.table.column.weatherCity'),
                name: 'weatherCity'
            },
            {
                title: Translator.translate('general.table.column.isThreephase'),
                name: 'isThreephase'
            },
            {
                title: Translator.translate('general.table.column.apNum'),
                name: 'apNum'
            }
        ];
    });

    renderTable() {
        const { homes, profile } = this.props;

        return (
            <FHETable
                idTable="managementDetailHome"
                columns={this.renderColumns(profile)}
                data={this.renderData(homes)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { homes, theme, history } = this.props;
        return (
            <Fragment>
                {homes.size > 0 ? (
                    this.renderTable()
                ) : (
                    <div style={{ color: theme.palette.text.primary }}>{Translator.translate(`generic.home.table.body.emptyDataSourceMessage`)}</div>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { managementId, history } = props;
    const homes = state.environments[history.environment].data.Homes.get('list').filter(Home => {
        return Home.get('managementId') === managementId;
    });
    return {
        profile: state.data.user,
        homes
    };
}

const styles = theme => ({
    enabled: {
        color: theme.palette.success.main
    },
    disabled: {
        color: theme.palette.error.main
    }
});
export default withRouter(
    renderEnvComponent('scenes/Management/Table/TableHome', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableHome)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Management/Table/TableHome.js